module.exports = __webpack_public_path__ + "b032c0426d3d335e3a221e1521118a14.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/skull.png
// module id = 531
// module chunks = 0